import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layout, Spin } from 'antd'
import '../../css/patient.scss'
import util from '../../util/util'
import AccountDeleteForm from '../../component/patient/account.delete.form'
import { fetchInProgress } from '../../store/action/patient.action'

const { Content, Footer } = Layout

const PatientDelete = (props) => {
  return (
    <Layout
      style={{
        padding: '0 0 0 0',
        height: '100vh',
        backgroundColor: '#DDDDDD',
      }}
    >
      <Content style={{ overflow: 'auto', background: 'white' }}>
        <Spin spinning={props.isLoading}>
          <AccountDeleteForm
            setLoading={(progress) => {
              props.setProgress(progress)
            }}
          />
        </Spin>
      </Content>
      <Footer className='main-footer'>{util.getCopyrightText()}</Footer>
    </Layout>
  )
}

PatientDelete.propTypes = {
  isLoading: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.patient.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setProgress: (progress) => dispatch(fetchInProgress(progress)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientDelete)
